'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var CID = require('cids');

var errCode = require('err-code');

module.exports = function (_ref) {
  var bitswap = _ref.bitswap;
  return /*#__PURE__*/function () {
    var _unwant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(keys) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // eslint-disable-line require-await
              if (!Array.isArray(keys)) {
                keys = [keys];
              }

              _context.prev = 1;
              keys = keys.map(function (key) {
                return new CID(key);
              });
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](1);
              throw errCode(_context.t0, 'ERR_INVALID_CID');

            case 8:
              return _context.abrupt("return", bitswap.unwant(keys));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 5]]);
    }));

    function unwant(_x) {
      return _unwant.apply(this, arguments);
    }

    return unwant;
  }();
};